import axios from 'axios';

export const apiUrl = () => window.location.hostname === 'localhost'
  ? 'http://localhost:5014'
  : window.location.origin;

export const assetBaseUrl = () => {
  const host = window.location.hostname;
  if (host.includes('dev') || host === 'localhost') {
    return 'https://assets.dev.ontik.io/';
  }
  if (host.includes('staging')) {
    return 'https://assets.staging.ontik.io/';
  }
  return 'https://assets.ontik.io/';
};

// Create an Axios instance
const api = axios.create({ baseURL: apiUrl() });

// Create a variable to store the interceptor ID
let authInterceptorId;

api.interceptors.response.use(response => {
  return response;
}, error => {

  if (error.config && error.config.bypassInterceptor) {
    return Promise.reject(error);
  }

  if (error.response) {
    const { status, data, config } = error.response;
    if (status === 404) {
      // Redirect to custom 404 page
      window.location.href = '/not-found';
    } else if (status === 500) {
      const errorMessage = data?.message || error.message || 'Server Error';
      const newRelicError = new Error(errorMessage);

      // Attach additional context for debugging
      window.newrelic.noticeError(newRelicError, {
        status,
        url: config.url,
        method: config.method,
        responseData: data
      });
    }
  }

  return Promise.reject(error);
});

// Function to set the Authorization Token
export const setAuthToken = (token) => {
  // Eject the previous interceptor, if it exists
  if (authInterceptorId !== undefined) {
    api.interceptors.request.eject(authInterceptorId);
  }

  // Add a new interceptor with the provided token
  if (token) {
    authInterceptorId = api.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }
};

export default api;



